import { CountrySelectorPage } from '@src/components/countries/CountrySelector';
import { Page } from '@src/components/layout/Page';
import { router } from '@src/providers/router';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Route as index_route } from '@routes/index';
import { VStack } from 'ui_2';
import { BiX } from 'react-icons/bi';
import { pageXPadding } from '@src/components/layout/Body';
import { useViewTransition } from '@src/hooks/useViewTransition';

export const Route = createFileRoute('/countrySelect')({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const { slideRightFullPage } = useViewTransition();

  const onClick = () => {
    if (router.history.canGoBack()) {
      return router.history.back();
    }
    return navigate({ to: index_route.to, viewTransition: slideRightFullPage });
  };

  return (
    <VStack className={`w-full gap-4 py-4 ${pageXPadding}`}>
      <div className='relative'>
        <button className='absolute right-0' onClick={onClick}>
          <BiX size={20} />
        </button>
        <CountrySelectorPage />
      </div>
    </VStack>
  );
}
